import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Helpers } from 'src/app/helpers';
import { PortalService } from 'src/app/services/portal.service';

@Injectable({ providedIn: 'root' })
export class ConcatTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private portalService : PortalService
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.concatTitle(routerState.root, '', ' | ');
    if (title) {
      this.title.setTitle(title);
    }
  }

  private concatTitle(route: ActivatedRouteSnapshot, title: string, separator: string): string {
    if (!route)
      return title;

    const sub = route.data ? this.getResolvedTitleForRoute(route) : undefined;
    if (sub) {
      let portal = this.portalService.portalConfiguation.value;
      if (portal.hasOwnProperty('SponsorName'))
        title = `${Helpers.getPlatformName()}${separator}${portal.SponsorName}${separator}${portal.DisplayName}${separator}${sub}`;
      else
        title = `${Helpers.getPlatformName()}${separator}${sub}`;
    }

    title = this.concatTitle(route.children[0], title, separator);

    return title;
  }
}
